const logistics = {
  id: "logistics",
  title: "Guest & Movement Logistics Management",
  questions: [
    {
      question: "How do you manage airport arrivals and departures for large groups?",
      answer: "We create detailed arrival-departure grids, monitor flights in real time, and deploy dedicated airport coordinators for smooth transfers."
    },
    {
      question: "Do you handle complete rooming list management?",
      answer: "Yes. We manage room allocation, special preferences, late arrivals, and upgrades in coordination with the hotel."
    },
    {
      question: "How do you track guest movement during multi-location events?",
      answer: "Through structured transport charts, staggered scheduling, and on-ground supervisors at each venue."
    },
    {
      question: "Can you manage VIP or leadership guest logistics separately?",
      answer: "Absolutely. We provide priority transfers, discreet handling, and personalized coordination for senior guests."
    },
    {
      question: "How do you prevent delays in group transfers?",
      answer: "By allocating buffer time, standby vehicles, and pre-defined boarding coordination points."
    },
    {
      question: "Do you provide dedicated help desks for guests?",
      answer: "Yes. We set up event help desks and on-call support lines to assist guests throughout the program."
    },
    {
      question: "How are last-minute guest additions or cancellations handled?",
      answer: "Our centralized coordination system allows quick updates to rooming, transport, and event access lists."
    },
    {
      question: "How do you manage baggage handling for large groups?",
      answer: "We coordinate with hotels and transport teams to ensure structured tagging and smooth luggage movement."
    },
    {
      question: "Can you handle simultaneous check-ins for large groups?",
      answer: "Yes. We pre-coordinate express check-ins with hotels and organize staggered arrival flows."
    },
    {
      question: "How do you ensure clear communication with all guests?",
      answer: "We use structured briefing notes, digital itineraries, and centralized communication channels for real-time updates."
    }
  ]
};

export default logistics;
